<template>
    <page :busy="busy">
        <div class="layout-box">
            <div class="layout-box-toolbar">
                <div class="section-menu">
                    <div class="layout-box-toolbar" v-if="enabledCategories.length != 0">
                        <h2 class="category-heading-toolbar">Categories</h2>
                        <ul class="section-menu-list">
                            <li
                                class="section-menu-list-item"
                                v-for="category in enabledCategories"
                                :key="category.id"
                            >{{ category.name }}</li>
                        </ul>
                    </div>
                </div>
            </div>
            <div class="layout-box-cards">
                <b-container
                    class="partner-container"
                    v-for="category in partnersСategoryList"
                    :key="category.id"
                > 
                    <div class="category-container">
                        <div class="category-heading">
                            <h3>{{ category.name }}</h3>
                        </div>
                    </div>
                    <b-row>
                        <b-col v-for="partner in category.partners.filter(partner => !partner.deleted)"
                            :key="partner.id">
                            <PartnerCard
                                :title="partner.title"
                                :subtitle="partner.subtitle"
                                :icon="partner.logo"
                                @click="() => showModal(partner)"
                            />
                        </b-col>
                    </b-row>
                </b-container>
                <LargeModal
                    :title="currentPartner.title"
                    :subtitle="currentPartner.subtitle"
                    :icon="currentPartner.logo"
                    :link="currentPartner.homepage"
                >
                    <template v-slot:header-tooltips>
                        <div class="tooltips" v-if="currentPartner.tooltips">
                            <span
                                v-for="tooltip in currentPartner.tooltips"
                                v-b-tooltip.hover="{ container: 'vue-app', variant: 'secondary' }"
                                :key="tooltip.id"
                                :title="tooltip.hover_text"
                            >{{ tooltip.text }}</span>
                        </div>
                    </template>
                    <template v-slot:left-content>
                        <div class="left-content" v-html="currentPartner.modal_text" />
                    </template>
                </LargeModal>
            </div>
        </div>
    </page>
</template>

<script>
import PartnerCard from '../../generic/partner-card/partner-card.vue';
import LargeModal from '../../generic/large-modal/large-modal.vue';
import { mapGetters } from 'vuex';
import API from './../../../api';
import Page from '../../generic/page/page.vue';

export default {
    name: 'PartnerList',
    components: {
        Page,
        PartnerCard,
        LargeModal,
    },
    data() {
        return {
            currentPartner: {},
            busy: false,
            partners: [],
            categories: [],
        };
    },

    computed: {
        hasCategories() {
            return this.categories.length > 0;
        },

        enabledCategories() {
            return this.categories.filter(category => category.deleted == false);
        },
        partnersСategoryList() {
            return this.partners.filter(category => !category.deleted && category.partners.length > 0)
        }

    },

    methods: {
        showModal(partner) {
            this.currentPartner = partner;
            this.$bvModal.show(`large-card-modal`);
        },
    },
    mounted() {
        (async () => {
            this.busy = true;
            try {
                const response = await API.get('/app/partner-cards/category/');
                this.partners = response.data;
                for (let i = 0; i < this.partners.length; i++) {
                    this.categories.push({
                        name: this.partners[i].name,
                        id: this.partners[i].id,
                        deleted: this.partners[i].deleted,
                    });
                }
            } catch (err) {
                this.errorToast({text: 'Could not load partners data.'})
            }
            this.busy = false;
        })();
    },
    beforeCreate() {
        document.body.className = 'lx-partner-list';
    },
};
</script>


<style lang="scss" scoped>
:deep(.container) {
    width: 100%;
    padding: 18px;
    margin-left: 96px !important;
    margin-right: 96px !important;
}

:deep(.col) {
    flex-grow: 0 !important;
}

.content-links {
    padding-top: 16px;
}

.category-container {
    display: flex;
    flex-direction: row;
    padding-left: 12px;
    padding-right: 12px;
    margin-bottom: 12px;
}

.layout-box {
    display: flex;
    flex-direction: row;
    flex: 0 0 auto;
    justify-content: flex-start;
    min-width: 0;
    min-height: 0;
}

.layout-box-toolbar {
    flex: 0 0 auto;
    min-width: 0;
    min-height: 0;
    display: block;
}

.section-menu {
    padding-left: 30px;
    padding-top: 22px;
}

.category-heading-toolbar {
    color: #222;
    font-size: 22px;
    line-height: 20px;
    font-weight: 400;
}

.section-menu-list {
    list-style: none;
    margin: 20px 0 40px;
    padding: 0;
}

.section-menu-list-item {
    margin-bottom: 13px;
    color: #222;
}

.category-heading {
    flex: 1 1 auto;
}

.tooltips {
    margin-left: 16px;
    display: inline-block;
}

.tooltips span {
    margin-right: 12px;
    font-weight: 400;
    font-size: 14px;
    cursor: default;
    border-bottom: 1px dotted #737376;
    color: #737376;
}

.category-heading h3 {
    font-size: 22px;
    line-height: 24px;
    color: #222;
    font-weight: 400;
}

:deep(.hovered) {
    border: 1px solid #0b4a9e !important;
    -webkit-transition: border 0.5s ease;
    -moz-transition: border 0.5s ease;
    -o-transition: border 0.5s ease;
    -ms-transition: border 0.5s ease;
    transition: border 0.5s ease;
    -webkit-box-shadow: 0 8px 6px -3px rgb(196, 199, 204);
    -moz-box-shadow: 0 8px 6px -3px rgb(196, 199, 204);
    box-shadow: 0 8px 6px -3px rgb(196, 199, 204);
    -webkit-transition: box-shadow 0.5s ease;
    -moz-transition: box-shadow 0.5s ease;
    -o-transition: box-shadow 0.5s ease;
    -ms-transition: box-shadow 0.5s ease;
    transition: box-shadow 0.5s ease;
    cursor: pointer;
}

:deep(.hovered .card-body .card-title) {
    color: #0b4a9e;
}

:deep(.card-img),
.card-img-top,
.card-img-bottom {
    width: 64px !important;
    height: 64px;
    object-fit: contain;
    padding-left: 1rem;
    padding-top: 1rem;
}

:deep(.card-title) {
    font-size: 16px;
    line-height: 20px;
    font-weight: 500;
    padding-top: 12px;
    color: #222;
}

:deep(.card-subtitle) {
    margin-top: 0px;
    text-overflow: ellipsis;
    overflow: hidden;
    display: -webkit-box;
    -webkit-line-clamp: 3;
    color: #737376;
    font-weight: 400;
}

:deep(.card) {
    max-width: 250px;
    max-height: 230px;
    width: 230px;
    height: 200px;
    margin: 12px;
}

@media (max-width: 1200px) {
    :deep(.card) {
        width: 200px;
        height: 200px;
    }
}

@media (max-width: 992px) {
    :deep(.card) {
        width: 180px;
        height: 180px;
    }

    :deep(.container) {
        margin-left: 24px !important;
        margin-right: 24px !important;
    }
}

@media (max-width: 567px) {
    :deep(.card) {
        width: 140px;
        height: 200px;
    }
    .tooltips {
        display: inline-grid;
    }

    :deep(.container) {
        margin-left: 12px !important;
        margin-right: 12px !important;
    }
}

@media (max-width: 415px) {
    :deep(.card) {
        width: 110px;
        height: 200px;
    }

    .layout-box-toolbar {
        display: none;
    }

    :deep(.card-title) {
        font-size: 14px;
        line-height: 18px;
        font-weight: 500;
        padding-top: 10px;
        color: #222;
    }

    :deep(.card-subtitle) {
        font-size: 12px;
    }

    :deep(.container) {
        margin-left: 0px !important;
        margin-right: 0px !important;
    }
}


:deep(.card-body) {
    padding: 1rem;
}
</style>

<style lang="scss">
body.lx-partner-list {
    overflow: hidden;
}
</style>